import { Validator } from 'jsonschema'
import Quill from 'quill';
import {saveAs} from 'file-saver';
import * as misc from './misc.js'
import './progressbar.min.js'
import 'quill/dist/quill.snow.css';
var Keyboard = Quill.import('modules/keyboard');
var Delta = Quill.import('delta');




import sceneSchema from './scene.schema.json' with {type: 'json'}
var sceneValidator = new Validator();
//console.log(sceneValidator);

import {ScenePlayer} from './ScenePlayer.js';
import {SceneTimer} from './SceneTimer.js';


//sceneValidator.throwFirst = true;

var keys = [];

window.onkeyup = function(e) { keys[e.keyCode] = false; }
window.onkeydown = function(e) { keys[e.keyCode] = true; }


const defaultSceneJSON = {
    id: null,
    info: {
        name: "Custom scene",
        description: "Enter your synopsis here",
        author: "author",
        ncharacters: 2,
        play: "",
        act: "",
        scene: "",
        genre: "Custom",
        theme: ["Custom"],
    },
    scene_data: {
        cast: [
            {
                id : 1,
                name : "Character 1",
                description: "Character 1",
                color : "#729fcf",
            },
            {
                id : 2,
                name : "Character 2",
                description: "Character 2",
                color : "#fce94f"
            }
        ],
        lines: [
            {
                id: 1,
                castId: 1,
                duration: 5.0,
                delay: 0.0,
                text: "Your lines go here!" 
            }
        ],
        duration: 5.0,
    }
};

const speedSettings = [
    {
        characters_per_second: 7.27,
        syllables_per_second: 1.79,
        words_per_second: 1.43,
        beats_per_second: 1.34,
    },
    {
        characters_per_second: 9.03,
        syllables_per_second: 2.23,
        words_per_second: 1.78,
        beats_per_second: 1.67,
    },
    {
        characters_per_second: 11.16,
        syllables_per_second: 2.75,
        words_per_second: 2.20,
        beats_per_second: 2.06,
    }
];


function getSanitizedTextData(str = "") {
    // Replace curly single and double quotes, em dashes, and ellipses
    var san1 = str.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"');
    var san2 = san1.replace(/[\u2013\u2014]/g, '-').replace(/[\u2026]/g, '...');

    return san2;
}

// List of properties in scene that have a matching UI element
export const ScenePropertyMappings = ["name", "description", "author", "genre", "play", "act", "scene"];

export class Scene {
    constructor(json = null) {
        if (json == null) {
            this.json = structuredClone(defaultSceneJSON);
        }
        else {
            // Validate json first
            let res = sceneValidator.validate(json, sceneSchema);
            if (res.valid) {
                this.json = structuredClone(json);
            }
            else {
                for(let err of res.errors) {
                    console.error(err);
                }   
            }
        }

        if (this.json != null) {
            this.createInputs();
        }
    }

    // Getters
    get lines() {
        return this.json.scene_data.lines;
    }

    get cast() { 
        return this.json.scene_data.cast;
    }

    get name() {
        return this.json.info.name;
    }

    get description() {
        return this.json.info.description;
    }

    get ncharacters() {
        return this.json.info.ncharacters;
    }

    get speed() {
        return this.json.scene_data.speed;
    }
    
    clear() {
        if (this.linesUI) {
            var tbody = document.getElementById("lines_tbody");
            this.linesUI.forEach(function(entry) {
                tbody.removeChild(entry);
            });
        }

        this.linesUI = [];
        this.durationsUI = [];
        this.delaysUI = [];
        this.quills = []
    }

    setDelayForAll(newDelay) {
        this.lines.forEach(function(line) {
            line.delay = newDelay;
        });

        this.recomputeTotalDuration();
    }

    computeLineTiming(entry) {
        var entryText = entry.text;
        // Take weighted average of characters per second and words per second
        var numWords = entryText.split(" ").length;
        var entryText = entry.text.replace(" ", "").replace("\n", "");

        var numCharacters = entryText.length;
        
        //var s = this.speed;
        var s = 1;
        var lower = 0, upper = 1;

        if (s > 0.5) {
            lower = 1;
            upper = 2;
            s -= 0.5;
        }

        s /= 0.5;

        var minC = speedSettings[lower].characters_per_second;
        var maxC = speedSettings[upper].characters_per_second;
        var minW = speedSettings[lower].words_per_second;
        var maxW = speedSettings[upper].words_per_second;

        var interp = function(t, a, b) {
            return (a * (1.0 - t)) + (b * t);
        }

        var interpC = interp(s, minC, maxC);
        var interpW = interp(s, minW, maxW);

        
        var charDuration = numCharacters / interpC;
        var wordDuration = numWords / interpW;
        var avgDuration = (charDuration + wordDuration) * 0.5;

        entry.duration = Math.round(avgDuration * 1e2) / 1e2;

        var index = entry.id - 1;
        if (index >= 0 && index < this.durationsUI.length) {
            this.durationsUI[entry.id - 1].value = entry.duration;
        }
    }

    recomputeTimings() {
        this.json.duration = 0;
        for(var i = 0; i < this.lines.length; i++) {
            this.computeLineTiming(this.lines[i]);
            this.json.duration += this.lines[i].duration;
        }
    }

    refreshTimings() {
        for(var i = 0; i < this.lines.length; i++) {
            this.durationsUI[i].value = this.lines[i].duration;
        }
    }

    refreshTotalDurationUI() {
        // let totalDuration = this.json.scene_data.duration;
        // // Get hours, minutes, seconds of scene
        // let hours = Math.floor(totalDuration / 3600);
        // let rem = totalDuration % 3600;
        // let minutes = Math.floor(rem / 60);
        // let seconds = rem % 60;
        // let frac = rem - seconds;

        // let hs = hours > 0 ? String(hours).padStart(2, '0') + ":" : "";
        // let ms = minutes > 0 ? String(minutes).padStart(2, '0') + ":" : "";
        // let ss = seconds.toFixed(3).padEnd(3, '0').padStart(2, '0');

        // let durationStr = `${hs}${ms}${ss}`;
        
        let durationStr = misc.secondsToHms(this.json.scene_data.duration, true, false, false);

        let totalSpan = document.getElementById("scene_duration_total");
        totalSpan.innerHTML = durationStr;
    }

    recomputeTotalDuration() {
        let totalDuration = 0;
        for(var i = 0; i < this.lines.length; i++) {
            totalDuration += this.lines[i].duration;

            if (this.lines[i].delay) {
                totalDuration += this.lines[i].delay;
            }
        }

        this.json.scene_data.duration = totalDuration;

        this.refreshTotalDurationUI();
    }

    refreshLineIndices() {
        var lineId = 1;
        this.lines.forEach(function(l) {
            l.id = lineId++;
        });
    }

    createInputs() {
        // Use for access in binding event handlers
        var mscene = this;

        //this.clearInputs();

        this.clear();

        this.refreshLineIndices();
        this.recomputeTotalDuration();

        if ("interval" in this.json.scene_data) {
            document.getElementById("default_delay").value = this.json.scene_data.interval;
        }
        (document.getElementById("default_delay").value);

        var div;
        var table, tbody, tr, td;

        this.props = {};

        for (let prop of ScenePropertyMappings) {
            var elem = document.getElementById(prop);
            elem.value = mscene.json.info[prop] ?? "";
            elem.addEventListener("change", function(event) {
                mscene.json.info[prop] = this.value;
            });
            this.props[prop] = elem;
        }

        // var sceneName = document.getElementById("sceneName");
        // sceneName.value = mscene.json.info.name;
        // sceneName.addEventListener("change", function(event) {
        //     mscene.json.info.name = this.value;
        // });

        // var sceneDescription = document.getElementById("sceneDescription");
        // sceneDescription.value = mscene.json.info.description;
        // sceneDescription.addEventListener("change", function(event) {
        //     mscene.json.info.description = this.value;
        // });

        // var sceneAuthor = document.getElementById("sceneAuthor");
        // sceneAuthor.value = mscene.json.info.author;
        // sceneAuthor.addEventListener("change", function(event) {
        //     mscene.json.info.author = this.value;
        // });

        // var sceneGenre = document.getElementById("sceneGenre");
        // sceneGenre.value = mscene.json.info.genre;
        // sceneGenre.addEventListener("change", function(event) {
        //     mscene.json.info.genre = this.value;
        // });

        // var sceneShowNext = document.getElementById("show_next_checkbox");
        // sceneShowNext.checked = mscene.json.scene_data.show_next;
        // sceneShowNext.addEventListener("change", function(event) {
        //     mscene.json.scene_data.show_next = sceneShowNext.checked;
        // });

        // Lines
        div = document.getElementById("lines_info");
        table = document.getElementById("lines_table");
        tbody = document.getElementById("lines_tbody");

        // Header row for lines
        // (1) Index, (2) Character, (3) Text (4) Duration
        this.lines.forEach(function(entry) {
            var inputObj;
            tr = document.createElement("tr");

            // number
            //td = document.createElement("td");
            //td.innerHTML = entry.id || "";
            //tr.appendChild(td);

            // character
            td = document.createElement("td");
            inputObj = mscene.getCastDropDown();
            
            // Assign any null cast IDs to the stage direction index
            if (entry.castId == null) {
                entry.castId = 0;
            }
            if (entry.castId == 0) {
                inputObj.options[inputObj.options.length - 1].selected = true;
            }
            else {
                var castIdFound = false;
                for(var j = 0; j < inputObj.options.length; j++) {
                    var jn = Number(inputObj.options[j].value);
                    if (jn === entry.castId) {
                        inputObj.options[j].selected = true;
                        castIdFound = true;
                        break;
                    }
                }
                if (!castIdFound) {
                    inputObj.options[inputObj.options.length - 1].selected = true;
                }
            }

            inputObj.addEventListener("change", function(event) {
                var castNum = Number(this.value);
                entry.castId = castNum;
            });
            let lineLabel = document.createElement("div");
            lineLabel.innerHTML = `Line ${entry.id}`;
            td.appendChild(lineLabel);
            td.appendChild(inputObj);
            tr.appendChild(td);

            // Text 
            td = document.createElement("td");
            var editor = mscene.getTextEditor(mscene, entry);
            td.appendChild(editor);
            tr.appendChild(td);

            // Duration
            var duration = entry.duration;
            td = document.createElement("td");
            var durationInputObj = document.createElement("input");
            durationInputObj.className = "numFieldEditor";
            durationInputObj.type = "text";
            durationInputObj.value = duration;

            mscene.durationsUI.push(durationInputObj);

            durationInputObj.addEventListener("change", function() {
                try {
                    var val = Number(durationInputObj.value);
                    if (val == val && val > 0) {
                        entry.duration = val;
                        mscene.recomputeTotalDuration();

                    }
                }
                catch(err) {
                    console.log(err.message);
                }
            });
            td.appendChild(durationInputObj);
            tr.appendChild(td);

             // Delay
            var delay = entry.delay ?? 0;
            td = document.createElement("td");
            var delayInputObj = document.createElement("input");
            delayInputObj.className = "numFieldEditor";
            delayInputObj.type = "text";
            delayInputObj.value = delay;

            mscene.delaysUI.push(delayInputObj);

            delayInputObj.addEventListener("change", function() {
                try {
                    var val = Number(delayInputObj.value);
                    if (val == val && val > 0) {
                        entry.delay = val;
                        mscene.recomputeTotalDuration();
                    }
                }
                catch(err) {
                    console.log(err.message);
                }
            });
            td.appendChild(delayInputObj);
            tr.appendChild(td);

            tbody.appendChild(tr);

            mscene.linesUI.push(tr);
        });
    }

    getIndexById(id, collection) {
        var entryIndex = -1;

        for(var j = 0; j < collection.length; j++) {
            if (collection[j].id == id) {
                entryIndex = j;
                break;
            }
        }

        return entryIndex;
    }

    getLineIndexById = function(id) {
        return this.getIndexById(id, this.lines);
    }

    getBlankLine = function() {
        var mscene = this;

        var newDelay = Number(document.getElementById("default_delay").value);

        return {
            id: 1,
            castId : 1,
            // Set offset and duration for all available speeds
            text : "",
            duration : 0,
            delay: newDelay
        };
    }

    getEditorToolbar(mscene, idPrefix) {
        var div = document.createElement("div");
        div.className = "toolbar ql-toolbar ql-snow formatting-container";
        div.id = idPrefix + "_toolbar";

        var clean = document.createElement("button");
        clean.title = "Clean";
        clean.className = "ql-clean";
        div.appendChild(clean);

        var bold = document.createElement("button");
        bold.title = "Bold";
        bold.className = "ql-bold";
        div.appendChild(bold);

        var italic = document.createElement("button");
        italic.title = "Italic";
        italic.className = "ql-italic";
        div.appendChild(italic);

        // Color
        var fmtGroup = document.createElement("span");
        fmtGroup.className = "ql-format-group";
        div.appendChild(fmtGroup);

        // var defaultColorClassName = "scene_editor ql-color/ ql-picker ql-color-picker";
        // var expandedColorClassName = "scene_editor ql-color ql-picker ql-color-picker ql-expanded";

        // var color = document.createElement("span");
        // color.title = "Font color"
        // color.className = defaultColorClassName;

        // var colorLabel = document.createElement("span");
        // var defaultPickerLabel = "ql-picker-label";
        // var activePickerLabel = "ql-picker-label ql-active";
        // colorLabel.className = defaultPickerLabel;
        // colorLabel.setAttribute("data-value", hexToRgbString("#ffffff"));
        // color.appendChild(colorLabel);

        // colorLabel.addEventListener("click", function(e) {
        //     if (color.className === defaultColorClassName) {
        //         color.className = expandedColorClassName;
        //     }
        //     else {
        //         color.className = defaultColorClassName;
        //     }
        // });

        // var colorSpans = document.createElement("span");
        // colorSpans.className = "ql-picker-options";
        // color.appendChild(colorSpans);

        // var colors = [];
        // colors.push({display: "Default color", color: "#d4c794"});

        // for(var c = 0; c < mscene.ncharacters; c++) {
        //     var castMember = mscene.cast[c];
        //     colors.push({display: castMember.name, color: castMember.color});
        // }

        // var colorSelect = document.createElement("select");
        // colorSelect.title = "Font color";
        // colorSelect.className = "ql-color";
        // //colorSelect.style = "display: none;";

        // var defaultSpanClassName = "ql-picker-item ql-primary-color";
        // var selectedSpanClassName = "ql-picker-item ql-primary-color ql-selected";

        // var selectedCspan;

        // colors.forEach(function (c) {
        //     var rgb = hexToRgbString(c.color);
        //     var cspan = document.createElement("span");
        //     colorSpans.appendChild(cspan);
        //     cspan.setAttribute("data-value", rgb);
        //     cspan.setAttribute("hex", c.color);
        //     cspan.className = defaultSpanClassName;

        //     var option = document.createElement("option");
        //     option.value = rgb;
        //     option.label = c.display;
        //     option.text = c.display;

        //     if (c.color === "#d4c794") {
        //         cspan.className = selectedSpanClassName;
        //         selectedCspan = cspan;
        //         option.setAttribute("selected", "");
        //     }

        //     cspan.style = "background-color: {0};".format(rgb);
        //     cspan.option = option;

        //     cspan.addEventListener("click", function(e) {
        //         // Unselect currently selected span
        //         if (selectedCspan) {
        //             selectedCspan.className = defaultSpanClassName;
        //             if (selectedCspan.option) {
        //                 delete selectedCspan.selected;
        //             }
        //         }
        //         // Select this span
        //         selectedCspan = this;
        //         this.className = selectedSpanClassName;
        //         this.option.setAttribute("selected", "");

        //         // Set color label's data-value
        //         colorLabel.setAttribute("data-value", this.getAttribute("data-value"));

        //         // Update color label
        //         var hex = this.getAttribute("hex");

        //         if (hex === "#d4c794") {
        //             colorLabel.className = defaultPickerLabel;
        //         }
        //         else {
        //             colorLabel.className = activePickerLabel;
        //         }

        //         color.className = defaultColorClassName;
        //     });


        //     colorSelect.appendChild(option);
        // });

        // div.appendChild(colorSelect);

        return div;
    }

    getTextEditor (mscene, entry) {
        var frag = document.createElement("div");
        frag.className = "editor-wrapper";

        var lastLine = mscene.lines[mscene.lines.length - 1];
        var idCheck = 0;

        //console.log("last line id check #" + (idCheck++).toString() + ": " + lastLine.id);

        var entrySuffix = (entry.id ? entry.id : "0");

        var idStr = "line_editor_id_" + entrySuffix;

        var brRegex = new RegExp(/<br ?\/?>/i);

        // Editor
        var editorDiv = document.createElement("div");
        editorDiv.id = "text-editor-" + idStr;
        editorDiv.className = "editor-container ql-snow";
        //var inputObj = new Quill(editorDiv, { formats: ['bold', 'italic', 'color'] });
        var editor_toolbar = this.getEditorToolbar(mscene, idStr);
        const toolbarOptions = [ ['clean'], ['bold', 'italic']];
        editor_toolbar.style.display = 'none';

        // Editor keyboard bindings
        const editorBindings = {
            addNewLine: {
                key: 'Enter',
                handler: function(range, context) {
                    var entryId = entry.id;

                    var newline = mscene.getBlankLine();
                    mscene.lines.splice(entryId, 0, newline);
                    mscene.createInputs();

                    var nextEntry = entryId;
                    if (nextEntry >= 0 && nextEntry < mscene.quills.length) {
                        mscene.quills[nextEntry].focus();
                    }

                    return false;
                }
            },
            addLineBreak: {
                key: 'Enter', 
                shiftKey: true, 
                handler: function(range, context) {
                    return true;
                }
            },
            // Add control so backspace on an empty editor deletes it 
            // (unless it's the only line left)
            deleteEmptyLine: {
                key: 'Backspace',
                handler: function(range, context) {
                    if (mscene.lines.length > 1 && context.empty) {
                        var entryId = entry.id;

                        mscene.lines.splice(entryId - 1, 1);
                        mscene.createInputs();

                        var nextEntry = entryId - 2;
                        if (nextEntry < 0) {
                            nextEntry = 0;
                        }
                        if (nextEntry < mscene.quills.length) {
                            mscene.quills[nextEntry].focus();
                        }

                        return false;
                    }

                    return true;
                }
            }
        };

        var inputObj = new Quill(editorDiv, {
            modules: {
                //toolbar: editor_toolbar
                toolbar: { container: editor_toolbar },
                keyboard: {
                    bindings: editorBindings
                }
                //toolbar: toolbarOptions
            },
            // formats: ['bold', 'italic'],
            theme: 'snow'
        });

        inputObj.clipboard.addMatcher(Node.TEXT_NODE, function(node, delta) {
            return new Delta().insert(node.data);
        });

        mscene.quills.push(inputObj);

        //var toolbar = this.getEditorToolbar(mscene, inputObj.id);
        //toolbar.id = "line_editor_toolbar_" + entrySuffix;
        //toolbar.style.display = 'none';
        //inputObj.addModule("toolbar", { container: toolbar });
        //inputObj.options.modules['toolbar'] = toolbar;

        // Whenever we select an editor, hide the previous editor's toolbar
        editorDiv.addEventListener('focusin', function(evt) {
            if (mscene.lastSelectedToolbar) {
                var ls = document.getElementById(mscene.lastSelectedToolbar);
                if (ls) {
                    ls.style.display = 'none';
                }
            }
            editor_toolbar.style.display = '';
            mscene.lastSelectedToolbar = editor_toolbar.id;
        });

        inputObj.on('text-change', function(delta, oldDelta, src) {
            entry.text = inputObj.getText().trim();
            entry.contents = inputObj.getContents();
            entry.html = inputObj.container.firstChild.innerHTML;

            let containsLineBreak = entry.text.includes('\n');

            if (containsLineBreak) {
                // Two cases - pasted (lots of p tags) or manual (lots of \n). Cover both with substitution
                entry.html = entry.html.replace(/\n/gi, "<br/>\n");
                entry.html = entry.html.replace(/<p>/gi, "").replace(/<\/p>/gi, "<br/>\n");
                // Remove last br
                let lastBR = entry.html.lastIndexOf("<br/>");
                if (lastBR >= 0) {
                    entry.html = entry.html.substring(0, lastBR);
                }

                entry.html = "<p>" + entry.html + "</p>";
            }

            // Try to estimate line speed based on settings
            if (src === 'user') {
                mscene.computeLineTiming(entry);
            };
        });

        //console.log("last line id check #" + (idCheck++).toString() + ": " + lastLine.id);

        inputObj.formatTextWithNewlines = function(text) {
            text = getSanitizedTextData(text).replace('')

            var texts = text.split(/\n|\r|(<br ?\/?>)/).filter(function (e) {
                // Only return if e isn't empty, undefined, or a <br>
                if (!e) {
                    return false;
                }
                if (e === "") {
                    return false;
                }
                //Ascii 13 is carriage return
                if (e === "\n" || e === "\r") {
                    return false;
                }
                if (brRegex.test(e)) {
                    return false;
                }

                return true;
            });

            var result = "";
            texts.forEach(function (t) {
                //console.log("contents: " + t);
                result = result + t.trim() + "<br />";
            });

            return result;
        };

        inputObj.setTextWithNewlines = function(text) {
            var result = inputObj.formatTextWithNewlines(text);
            inputObj.setHTML(result);
        };

        inputObj.setHTMLWithNewlines = function(html) {
            var html2 = inputObj.formatTextWithNewlines(html);
            inputObj.setHTML(html2);
        };

        inputObj.parsePastedHTML = function(html) {
            var div = document.createElement("div");
            div.innerHTML = html;

            var children = div.childNodes;

            for(var i = 0; i < children.length; i++) {
                console.log(children[i].innerHTML);
            }

            return html;
        };
        // editorDiv.addEventListener("paste", function(e) {
        //     e.preventDefault();

        //     var text = e.clipboardData.getData("text/plain");
        //     //var result = inputObj.formatTextWithNewlines(text);
        //     document.execCommand("insertHTML", false, text);
        // });

        if (entry.contents) {
            inputObj.setContents(entry.contents);
        }
        else {
            inputObj.setText(entry.text);
        }
        

        frag.appendChild(editor_toolbar);
        frag.appendChild(editorDiv);

        //console.log("last line id check #" + (idCheck++).toString() + ": " + lastLine.id);

        return frag;
    }

    getCastDropDown() {
        var dropdown = document.createElement("select");

        var maxShow = Number(this.json.info.ncharacters);

        for(var i = 0; i < maxShow; i++)
        {
            var nextOption = new Option(this.cast[i].name, this.cast[i].id.toString());
            nextOption.style = "background-color: " + this.cast[i].color + "; color: #000000;";
            dropdown.options.add(nextOption);
        }

        dropdown.options.add(new Option("Stage Direction", "0"));

        return dropdown;
    }

    getSceneText() {

        //var customOutput = JSON.stringify(mekInfo, null, 2);
        var customOutput = JSON.stringify(this.json, null, 2);

        customOutput += "\n\n";

        var entries = this.exportHTML(true, true, true, true, this.show_next ?? false);

        customOutput += entries.join("");

        return customOutput;
    }

    saveJSONToFile() {

        //var txt = this.getSceneText();
        var txt = JSON.stringify(this.json, null, 4);

        var saveBlob = new Blob([txt], {type: "text/plain"});
        saveAs(saveBlob, this.name + ".json");
    }

    saveSRTToFile () {
        var entries = this.exportHTML(true, true, true, true, this.show_next ?? false);

        var txt = entries.join("");

        var saveBlob = new Blob([txt], {type: "text/plain"});
        saveAs(saveBlob, this.name + ".srt");
    }

    saveJSRTToFile () {

        var txt = JSON.stringify(this.json, null, 4);

        var entries = this.exportHTML(true, true, true, true, this.show_next ?? false);

        txt += "\n\n" + entries.join("");

        var saveBlob = new Blob([txt], {type: "text/plain"});
        saveAs(saveBlob, this.name + ".jsrt");
    }

    exportHTML (includeIDs = true, includeTimestamps = true,
        includeFormatting = true, addSpaceBetweenLineAndActor = false, includeNextLines = true,
        includeColors = true) {

        var entries = [];
        var srt = "";
        var divRegex = new RegExp(/<\/?div ?\/?>/i);

        var mscene = this;

        // Dictionary for cast
        var castDict = {};

        // Dictionary for lines
        var lineDict = {};

        this.cast.forEach(function (c) {
            castDict[c.id] = c;
        });

        this.lines.forEach(function (l) {
            lineDict[l.id] = l;
        });

        // Function we can use for getting file-friendly lines
        var getLineTextForFile = function(entry) {
            var entryHTML = includeFormatting ? entry.html : entry.text;
            // Quill always includes a newline at the end, so remove that here
            var result = "";
            // Sanitize output
            var sanitized = getSanitizedTextData(entryHTML);
            // Convert divs to newline characters
            // var lines = sanitized.split(/<\/?div ?\/?>/i).filter(function (e) {
            //     // Only return if e isn't empty, undefined, or a <br>
            //     if (!e) {
            //         return false;
            //     }
            //     if (e === "") {
            //         return false;
            //     }
            //     // Ascii 13 is carriage return
            //     if (e === "\n" || e === "\r") {
            //         return false;
            //     }
            //     if (divRegex.test(e)) {
            //         return false;
            //     }

            //     return true;
            // });

            if (entry.castId && entry.castId in castDict) {
                // Add actor line
                result += String.format("{0}:<br/>\r\n", castDict[entry.castId].name);
                if (addSpaceBetweenLineAndActor) {
                    result += "<br/>";
                }
            }

            result += sanitized.split("\n").join("\r\n");

            // Add lines
            // lines.forEach(function (e) {
            //     result += String.format("{0}{1}\r\n", e,
            //         (lines.length === 1 || e === lines[lines.length - 1]) ?
            //         "" : "<br/>");
            // })

            result += "<br/>";

            return result;
        }

        var srtStartTime = 0;

        this.lines.forEach(function (entry) {
            srt = "";
            // Id
            if (includeIDs) {
                srt += String.format("{0}\r\n", entry.id);
            }

            var srtEndTime = srtStartTime + entry.duration;

            // Timestamps
            if (includeTimestamps) {
                srt += String.format("{0} --> {1}\r\n", misc.secondsToHms(srtStartTime),
                    misc.secondsToHms(srtEndTime));
            }

            srtStartTime = srtEndTime + (entry.delay ?? 0);

            // Actor info
            var useActorParagraph = entry.castId && entry.castId in castDict;

            if (useActorParagraph) {
                srt += String.format("<p name=\"{0}\">\r\n", castDict[entry.castId].name);
                if (includeColors) {
                    srt += String.format('<span style="color: #{0};">\r\n', castDict[entry.castId].color);
                }
            }

            // The line itself
            var lineText = getLineTextForFile(entry);

            srt += lineText;


            // Closing tags for actor info
            if (useActorParagraph) {
                if (includeColors) {
                    srt += "</span>\r\n";
                }
                srt += "</p>\r\n";
            }
            else {
                srt += "\r\n";
            }

            // If we're generating next line, then handle it here
            if (lineDict[entry.id + 1] && includeNextLines) {
                srt += String.format("<p class=\"next\">\r\n");
                var nextText = getLineTextForFile(lineDict[entry.id + 1]);
                srt += nextText;
                srt += "</p>\r\n"
            }

            srt += "\r\n";

            entries.push(srt);
        });

        //console.log("Done exporting. Value: " + srt);

        return entries;
    }

    exportPlaintext () {
        var plaintext = "";
        var divRegex = new RegExp(/<\/?div ?\/?>/i);

        var mscene = this;

        // Dictionary for cast
        var castDict = {};

        // Dictionary for lines
        var lineDict = {};

        this.cast.forEach(function (c) {
            castDict[c.id] = c;
        });

        this.lines.forEach(function (l) {
            lineDict[l.id] = l;
        });

        // Function we can use for getting file-friendly lines
        var getLineTextForFile = function(entry) {
            var entryHTML = entry.text;
            return getSanitizedTextData(entryHTML);
        }

        this.lines.forEach(function (entry) {
            var srt = "";

            // Actor info
            var useActorParagraph = entry.castId && entry.castId in castDict;

            if (useActorParagraph) {
                srt += castDict[entry.castId].name + ":\r\n";
            }

            // The line itself
            var lineText = getLineTextForFile(entry);

            srt += lineText;
            srt += "\r\n\r\n";

            plaintext += srt;
        });

        //console.log("Done exporting. Value: " + srt);

        return plaintext;
    }

    getPlayer = function() {
        return new ScenePlayer(this);
    }

    getTimer = function() {
        return new SceneTimer(this);
    }
}